import styled from 'styled-components';

export const question = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0;
`;

export const questionSelector = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
